export const linksUtil = {
    trimHttp(link = "") {
        return link.replace(/^https?:\/\//, "");
    },
};
